import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { register as registerApi } from './api/auth';
import './Auth.css';

const AUTH_TOKEN_KEY = 'access_token';
const AUTH_USER_KEY = 'user';

const Register = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) return;

    setError('');
    setLoading(true);

    const name = [firstName.trim(), lastName.trim()].filter(Boolean).join(' ');

    try {
      const data = await registerApi({
        username: email.trim(),
        password,
        name: name || undefined,
      });

      localStorage.setItem(AUTH_TOKEN_KEY, data.access_token);
      localStorage.setItem(AUTH_USER_KEY, JSON.stringify(data));

      if (inviteCode.trim()) {
        localStorage.setItem('invite_code', inviteCode.trim());
      }

      navigate('/console');
    } catch (err) {
      setError(err.message || '注册失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <aside className="auth-brand">
        <div className="auth-brand-inner">
          <Link to="/dashboard" className="auth-logo">
            <span className="auth-logo-icon">T</span>
            TokenAI
          </Link>
          <h1>
            加入 TokenAI
            <br />
            <span className="gradient">开始构建未来</span>
          </h1>
          <p className="auth-brand-desc">
            注册即可获得免费试用额度，体验强大的 AI 模型调用服务。
          </p>
          <ul className="auth-benefits">
            <li>免费试用 10,000 令牌</li>
            <li>支持 50+ 主流 AI 模型</li>
            <li>99.9% 服务可用性保证</li>
            <li>7x24 技术支持</li>
          </ul>
        </div>
        <p className="auth-brand-footer">TokenAI - 新一代 AI 令牌服务平台</p>
      </aside>

      <div className="auth-form-panel">
        <div className="auth-form-top">
          <Link to="/dashboard" className="auth-logo-mobile">
            <span className="auth-logo-icon">T</span>
            TokenAI
          </Link>
          <Link to="/dashboard" className="auth-back-home">
            ← 返回首页
          </Link>
        </div>

        <div className="auth-form-body">
          <div className="auth-form-wrap">
            <div className="auth-form-header">
              <h2>创建账户</h2>
              <p>填写以下信息完成注册</p>
            </div>

            <div className="auth-oauth">
              <button type="button" className="auth-oauth-btn">
                <span className="auth-oauth-icon">⬡</span>
                GitHub
              </button>
              <button type="button" className="auth-oauth-btn">
                <span className="auth-oauth-icon">G</span>
                Google
              </button>
            </div>

            <div className="auth-divider">或使用邮箱注册</div>

            <form className="auth-form" onSubmit={handleSubmit}>
              {error && <div className="auth-error">{error}</div>}

              <div className="auth-field-row">
                <div className="auth-field">
                  <label htmlFor="firstName">名字</label>
                  <input
                    id="firstName"
                    type="text"
                    placeholder="名"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    autoComplete="given-name"
                    disabled={loading}
                    required
                  />
                </div>
                <div className="auth-field">
                  <label htmlFor="lastName">姓氏</label>
                  <input
                    id="lastName"
                    type="text"
                    placeholder="姓"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    autoComplete="family-name"
                    disabled={loading}
                    required
                  />
                </div>
              </div>

              <div className="auth-field">
                <label htmlFor="email">邮箱地址</label>
                <input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  disabled={loading}
                  required
                />
              </div>

              <div className="auth-field">
                <label htmlFor="regPassword">密码</label>
                <input
                  id="regPassword"
                  type="password"
                  placeholder="至少 6 位字符"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  minLength={6}
                  disabled={loading}
                  required
                />
              </div>

              <div className="auth-field">
                <label htmlFor="inviteCode">邀请码（选填）</label>
                <input
                  id="inviteCode"
                  type="text"
                  placeholder="如有邀请码请填写"
                  value={inviteCode}
                  onChange={(e) => setInviteCode(e.target.value)}
                  disabled={loading}
                />
              </div>

              <label className="auth-checkbox-row">
                <input
                  type="checkbox"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  disabled={loading}
                  required
                />
                <span>
                  我已阅读并同意
                  <a href="https://token.bytrabbit.com" target="_blank" rel="noreferrer"> 服务条款 </a>
                  和
                  <a href="https://token.bytrabbit.com" target="_blank" rel="noreferrer"> 隐私政策</a>
                </span>
              </label>

              <div className="auth-recaptcha">
                <span className="auth-recaptcha-label">人机验证</span>
                <p className="auth-recaptcha-hint">
                  若验证码区域未显示，通常是当前网络无法访问 reCAPTCHA 资源。
                </p>
              </div>

              <button type="submit" className="auth-submit" disabled={!agreed || loading}>
                {loading ? '注册中…' : '创建账户'}
              </button>
            </form>

            <p className="auth-form-footer">
              已有账户？<Link to="/login">立即登录</Link>
            </p>
          </div>
        </div>

        <p className="auth-form-bottom">TokenAI - 新一代 AI 令牌服务平台</p>
      </div>
    </div>
  );
};

export default Register;
